import {allCopilotTools, ChatMessageTool} from "@buildwithflux/models";

export function getToolsFromMessage(message: string): ChatMessageTool[] {
    const toolTypes = allCopilotTools;
    const mentionPattern = new RegExp(`@(${toolTypes.join("|")})\\b`, "g");
    const matches = message.match(mentionPattern);

    // TODO: also support mentions of Objects as well as users
    return (matches ? matches.map((mention) => mention.slice(1)) : []) as ChatMessageTool[];
}
